import Vue from 'vue'
import Router from 'vue-router'

import auth from '@/services/auth'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')
// Views - public pages
const Page404 = () => import ('@/views/pages/Page404')
const Redirect = () => import ('@/views/pages/Redirect')

Vue.use(Router)

const router = new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/reservations',
      name: 'Home',
      component: DefaultContainer,
      children: [
        {
          path: 'reservations',
          name: 'Reservations',
          component: () => import('@/views/reservations/Reservations.vue'),
          meta: {
            requiresAuth: true,
            module: 'CLEANING',
            role: ['admin']
          }
        },
        {
          path: 'reservations/fleet-events/:reservationId',
          name: 'FleetEvents',
          component: () => import('@/views/reservations/FleetEvents.vue'),
          meta: {
            requiresAuth: true,
            module: 'CLEANING',
            role: ['admin']
          }
        },
        {
          path: 'cleaning',
          name: 'Cleaning',
          component: () => import('@/views/cleaning/Cleaning.vue'),
          meta: {
            requiresAuth: true,
            module: 'CLEANING',
            role: ['ops-cleaning']
          }
        }
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404,
          meta: {
            requiresAuth: false
          }
        },
        {
          path: 'redirect',
          name: 'Redirect',
          props: (route) => ({ query: route.query.hash }, {query: route.query.user}),
          component: Redirect,
          meta: {
            requiresAuth: false
          }
        }
      ]
    },
    {
      path: '*',
      redirect: '/pages/404'
    }
  ]
})

const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// navigation guards
router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (auth.checkToken()) {
      next()
    } else {
      auth.redirect()
    }
  } else {
    next()
  }
})

export default router
